import React from "react";

export const DropdownArrow = ({ isOpen, color }) => {
  return (
    <svg
      width="13"
      height="8"
      viewBox="0 0 13 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`dropdown_arrow ${isOpen ? "" : "open"}`}
    >
      <path
        d="M11.91 7.56754L12.97 6.50654L7.193 0.727544C7.10043 0.63439 6.99036 0.560461 6.86911 0.510013C6.74786 0.459565 6.61783 0.433594 6.4865 0.433594C6.35517 0.433594 6.22514 0.459565 6.10389 0.510013C5.98264 0.560461 5.87257 0.63439 5.78 0.727544L0 6.50654L1.06 7.56654L6.485 2.14254L11.91 7.56754Z"
        fill={color ? color : "#EE7225"}
      />
    </svg>
  );
};

export const FaEnvelope = () => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V2C20 0.9 19.1 0 18 0ZM17.6 4.25L10.53 8.67C10.21 8.87 9.79 8.87 9.47 8.67L2.4 4.25C2.29973 4.19371 2.21192 4.11766 2.14189 4.02645C2.07186 3.93525 2.02106 3.83078 1.99258 3.71937C1.96409 3.60796 1.9585 3.49194 1.97616 3.37831C1.99381 3.26468 2.03434 3.15581 2.09528 3.0583C2.15623 2.96079 2.23632 2.87666 2.33073 2.811C2.42513 2.74533 2.53187 2.69951 2.6445 2.6763C2.75712 2.65309 2.87328 2.65297 2.98595 2.67595C3.09863 2.69893 3.20546 2.74453 3.3 2.81L10 7L16.7 2.81C16.7945 2.74453 16.9014 2.69893 17.014 2.67595C17.1267 2.65297 17.2429 2.65309 17.3555 2.6763C17.4681 2.69951 17.5749 2.74533 17.6693 2.811C17.7637 2.87666 17.8438 2.96079 17.9047 3.0583C17.9657 3.15581 18.0062 3.26468 18.0238 3.37831C18.0415 3.49194 18.0359 3.60796 18.0074 3.71937C17.9789 3.83078 17.9281 3.93525 17.8581 4.02645C17.7881 4.11766 17.7003 4.19371 17.6 4.25Z"
        fill="#575757"
      />
    </svg>
  );
};
export const FaLock = () => {
  return (
    <svg
      width="16"
      height="22"
      viewBox="0 0 16 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 16.5C8.53043 16.5 9.03914 16.2893 9.41421 15.9142C9.78929 15.5391 10 15.0304 10 14.5C10 13.9696 9.78929 13.4609 9.41421 13.0858C9.03914 12.7107 8.53043 12.5 8 12.5C7.46957 12.5 6.96086 12.7107 6.58579 13.0858C6.21071 13.4609 6 13.9696 6 14.5C6 15.0304 6.21071 15.5391 6.58579 15.9142C6.96086 16.2893 7.46957 16.5 8 16.5ZM14 7.5C14.5304 7.5 15.0391 7.71071 15.4142 8.08579C15.7893 8.46086 16 8.96957 16 9.5V19.5C16 20.0304 15.7893 20.5391 15.4142 20.9142C15.0391 21.2893 14.5304 21.5 14 21.5H2C1.46957 21.5 0.960859 21.2893 0.585786 20.9142C0.210714 20.5391 0 20.0304 0 19.5V9.5C0 8.96957 0.210714 8.46086 0.585786 8.08579C0.960859 7.71071 1.46957 7.5 2 7.5H3V5.5C3 4.17392 3.52678 2.90215 4.46447 1.96447C5.40215 1.02678 6.67392 0.5 8 0.5C8.65661 0.5 9.30679 0.629329 9.91342 0.880602C10.52 1.13188 11.0712 1.50017 11.5355 1.96447C11.9998 2.42876 12.3681 2.97995 12.6194 3.58658C12.8707 4.19321 13 4.84339 13 5.5V7.5H14ZM8 2.5C7.20435 2.5 6.44129 2.81607 5.87868 3.37868C5.31607 3.94129 5 4.70435 5 5.5V7.5H11V5.5C11 4.70435 10.6839 3.94129 10.1213 3.37868C9.55871 2.81607 8.79565 2.5 8 2.5Z"
        fill="#575757"
      />
    </svg>
  );
};

export const FaGlobe = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM18 10C18 10.46 17.96 10.91 17.88 11.35H14.54C14.6 10.91 14.63 10.45 14.63 10C14.63 9.55 14.6 9.09 14.54 8.65H17.88C17.96 9.09 18 9.54 18 10ZM17.08 6.65H14.42C14.04 5.76 13.56 4.93 12.97 4.2C14.44 4.87 15.78 5.65 17.08 6.65ZM16.58 13.35H13.9C14.28 14.24 14.76 15.07 15.35 15.8C13.88 15.13 12.54 14.35 11.24 13.35H16.58ZM10 18.7C9.44 18.7 8.76 17.78 8.35 16.35H11.65C11.24 17.78 10.56 18.7 10 18.7ZM8.37 13.35C8.03 12.58 7.77 11.75 7.65 10.9H12.35C12.23 11.75 11.97 12.58 11.63 13.35H8.37ZM8.37 6.65C8.03 7.42 7.77 8.25 7.65 9.1H12.35C12.23 8.25 11.97 7.42 11.63 6.65H8.37ZM10 1.3C10.56 1.3 11.24 2.22 11.65 3.65H8.35C8.76 2.22 9.44 1.3 10 1.3ZM7.03 4.2C6.44 4.93 5.96 5.76 5.58 6.65H2.92C4.22 5.65 5.56 4.87 7.03 4.2ZM2.92 13.35H5.58C5.96 14.24 6.44 15.07 7.03 15.8C5.56 15.13 4.22 14.35 2.92 13.35ZM5.37 8.65C5.4 9.09 5.43 9.55 5.43 10C5.43 10.45 5.4 10.91 5.37 11.35H2.12C2.04 10.91 2 10.46 2 10C2 9.54 2.04 9.09 2.12 8.65H5.37Z"
        fill="#575757"
      />
    </svg>
  );
};

export const FaLogout = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 7L15.59 8.41L18.17 11H8V13H18.17L15.59 15.59L17 17L22 12L17 7ZM4 5H12V3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H12V19H4V5Z"
        fill="#575757"
      />
    </svg>
  );
};
